"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stopTracking = exports.trackEvent = exports.identifyUser = exports.endSession = exports.init = void 0;
var amplitude = require("@amplitude/analytics-browser");
var SESSION_TIMEOUT = 1000 * 60 * 30;
var ANALYTICS_LOCAL_STORAGE_KEY = 'analytics_local_settings';
var START_SESSION_EVENT = 'start-session';
var END_SESSION_EVENT = 'end-session';
var MAX_RANDOM = 99999;
var appPrefix = '';
var sessionTimeout = SESSION_TIMEOUT;
var sessionTimeoutID = -1;
var analyticsCallbacks = {};
var analyticsLocalSettings = initSettings();
function generateSessionID() {
    return Math.floor(new Date().getTime() + Math.random() * MAX_RANDOM);
}
function initSettings() {
    var _a = JSON.parse(localStorage.getItem(ANALYTICS_LOCAL_STORAGE_KEY) || '{}'), currentSessionID = _a.currentSessionID, timestampLastFiredEvent = _a.timestampLastFiredEvent, isActiveSession = _a.isActiveSession;
    return {
        timestampLastFiredEvent: timestampLastFiredEvent || 0,
        currentSessionID: currentSessionID || generateSessionID(),
        isActiveSession: isActiveSession || false
    };
}
function saveLocalSettings() {
    localStorage.setItem(ANALYTICS_LOCAL_STORAGE_KEY, JSON.stringify(analyticsLocalSettings));
}
function getCurrentSessionID() {
    return analyticsLocalSettings.currentSessionID;
}
function resetSessionID() {
    var newSessionId = generateSessionID();
    amplitude.setSessionId(newSessionId);
    analyticsLocalSettings.currentSessionID = newSessionId;
    saveLocalSettings();
}
function isActiveSession() {
    return analyticsLocalSettings.isActiveSession;
}
function setActiveSession(value) {
    analyticsLocalSettings.isActiveSession = value;
    saveLocalSettings();
}
function closeCurrentSession() {
    if (!amplitude.getUserId()) {
        return;
    }
    amplitude.track("".concat(appPrefix, "/").concat(END_SESSION_EVENT), { source: appPrefix });
    amplitude.flush();
    setActiveSession(false);
}
function startSession(onLogin) {
    if (onLogin) {
        resetSessionID();
        if (amplitude.getUserId()) {
            amplitude.track("".concat(appPrefix, "/").concat(START_SESSION_EVENT), {
                source: appPrefix
            });
            amplitude.flush();
        }
        setActiveSession(true);
    }
}
function setEndSessionTimeout() {
    clearTimeout(sessionTimeoutID);
    sessionTimeoutID = window.setTimeout(closeCurrentSession, sessionTimeout);
}
function setTimestampLastFiredEvent(value) {
    analyticsLocalSettings.timestampLastFiredEvent = value;
    saveLocalSettings();
    setEndSessionTimeout();
}
function getTimestampLastFiredEvent() {
    return analyticsLocalSettings.timestampLastFiredEvent;
}
function isStaleSession() {
    var currentTime = new Date().getTime();
    return currentTime - sessionTimeout >= getTimestampLastFiredEvent();
}
function init(_a) {
    var token = _a.token, appName = _a.appName, callbacks = _a.callbacks, amplitudeConfig = _a.amplitudeConfig;
    appPrefix = appName;
    sessionTimeout = (amplitudeConfig === null || amplitudeConfig === void 0 ? void 0 : amplitudeConfig.sessionTimeout) || SESSION_TIMEOUT;
    var config = __assign(__assign({}, amplitudeConfig), { sessionTimeout: sessionTimeout + 1000 });
    if (callbacks) {
        Object.assign(analyticsCallbacks, callbacks);
    }
    try {
        amplitude.init(token, __assign(__assign({}, config), { defaultTracking: false }));
        amplitude.setOptOut(false);
        amplitude.setSessionId(getCurrentSessionID());
        return true;
    }
    catch (error) {
        return false;
    }
}
exports.init = init;
function endSession() {
    closeCurrentSession();
    amplitude.setUserId(undefined);
    resetSessionID();
    if (analyticsCallbacks.onSessionEnd) {
        analyticsCallbacks.onSessionEnd();
    }
}
exports.endSession = endSession;
function identifyUser(user, onLogin, associatedGroup, deprecatedUserProps) {
    amplitude.setUserId(user.userId);
    var userProperties = new amplitude.Identify();
    Object.entries(user).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        userProperties.set(key, value);
    });
    if (deprecatedUserProps) {
        deprecatedUserProps.forEach(function (prop) {
            userProperties.unset(prop);
        });
    }
    amplitude.identify(userProperties);
    if (isActiveSession() && isStaleSession()) {
        amplitude.setSessionId(getCurrentSessionID());
        closeCurrentSession();
    }
    startSession(onLogin);
    if (associatedGroup) {
        amplitude.setGroup(associatedGroup.groupType, associatedGroup.groupValue);
    }
}
exports.identifyUser = identifyUser;
function trackEvent(event) {
    if (isStaleSession()) {
        startSession(true);
    }
    amplitude.track(event.name, event.properties);
    setTimestampLastFiredEvent(new Date().valueOf());
}
exports.trackEvent = trackEvent;
function stopTracking() {
    endSession();
    amplitude.setOptOut(true);
}
exports.stopTracking = stopTracking;
